import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenAcsVisitsIndicatorC3Data } from "@/services/esus/indicator/esf/c3/getDetailedCitizensAcsVisitsIndicatorC3";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC3CitizensAcsVisitsHistoryItem } from "./IndicatorEsfC3CitizensAcsVisitsHistoryItem";
import { IndicatorEsfC3CitizensAcsVisitsHistoryInfo } from "./IndicatorEsfC3CitizensAcsVisitsHistoryInfo";

type IndicatorEsfC3CitizensAcsVisitsHistoryProps = {
	citizenWithAcsHomeVisits: DetailedCitizenAcsVisitsIndicatorC3Data;
};

export function IndicatorEsfC3CitizensAcsVisitsHistory({
	citizenWithAcsHomeVisits,
}: Readonly<IndicatorEsfC3CitizensAcsVisitsHistoryProps>) {
	const indicatorEsfC1CitizenHistoryInfo = {
		fullName: citizenWithAcsHomeVisits.fullName ?? "N/A",
		birthdate: citizenWithAcsHomeVisits.birthdate
			? dayjs(citizenWithAcsHomeVisits.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithAcsHomeVisits.cpf
			? formatIdentifier(citizenWithAcsHomeVisits.cpf)
			: citizenWithAcsHomeVisits.cns ?? "",
		motherName: citizenWithAcsHomeVisits.motherName ?? "",
		phone: citizenWithAcsHomeVisits.phone ? phoneFormat(citizenWithAcsHomeVisits.phone) : "",
		address:
			addressConcat(
				citizenWithAcsHomeVisits.street,
				citizenWithAcsHomeVisits.houseNumber,
				citizenWithAcsHomeVisits.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC3CitizensAcsVisitsHistoryInfo {...indicatorEsfC1CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Visitas - puerpério"
				timeLineContents={(
					citizenWithAcsHomeVisits.puerperalAcsHomeVisits ?? []
				).map<TimeLineContent>((homeVisit) => {
					return {
						content: (
							<IndicatorEsfC3CitizensAcsVisitsHistoryItem homeVisit={homeVisit} />
						),
						eventDate: homeVisit.date
							? dayjs(homeVisit.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Visitas - gestação"
				timeLineContents={(
					citizenWithAcsHomeVisits.acsHomeVisits ?? []
				).map<TimeLineContent>((homeVisit) => {
					return {
						content: (
							<IndicatorEsfC3CitizensAcsVisitsHistoryItem homeVisit={homeVisit} />
						),
						eventDate: homeVisit.date
							? dayjs(homeVisit.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
